import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default _ref => {
  let {
    components,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `请提供一个尽可能精简的链接 `, /*#__PURE__*/React.createElement("a", {
    href: "https://u.ant.design/reproduce",
    target: "_blank"
  }, `antd@5.x`), ` / `, /*#__PURE__*/React.createElement("a", {
    href: "https://u.ant.design/codesandbox-repro-4x",
    target: "_blank"
  }, `antd@4.x`), ` 或是 GitHub 仓库的链接。
`, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "#repro-modal"
    }
  }, `什么是最小化重现，为什么这是必需的？`)));
};